export class LazyGLBRenderer {
    canRender(item) {
        return item.kind === '3d_model';
    }
    mount(container, item, opts) {
        let inner = null;
        let destroyed = false;
        const pendingUpdates = [];
        let pendingThreshold = null;
        void import('./GLBRenderer')
            .then(({ GLBRenderer }) => {
            if (destroyed)
                return;
            inner = new GLBRenderer().mount(container, item, opts);
            for (const partial of pendingUpdates)
                inner.update(partial);
            pendingUpdates.length = 0;
            if (pendingThreshold !== null)
                inner.setClickThreshold?.(pendingThreshold);
        })
            .catch((err) => {
            if (!destroyed) {
                opts.onError?.(err instanceof Error ? err : new Error(String(err)));
            }
        });
        return {
            update(partial) {
                if (inner)
                    inner.update(partial);
                else
                    pendingUpdates.push(partial);
            },
            setClickThreshold(pxSquared) {
                if (inner)
                    inner.setClickThreshold?.(pxSquared);
                else
                    pendingThreshold = pxSquared;
            },
            destroy() {
                destroyed = true;
                inner?.destroy();
                inner = null;
            },
        };
    }
}
//# sourceMappingURL=LazyGLBRenderer.js.map